import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { CompanyProductPotentialModel } from 'src/models';

const companyProductPotentialAdapter: AdapterFunc<
  GQL.CompanyProductPotentialModel,
  CompanyProductPotentialModel
> = (input) => ({
  id: input.id,
  name: input.name!,
  description: input.description!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default companyProductPotentialAdapter;
